<template>
  <sn-modal
    v-model="showDialog"
    :title="title"
    type="confirmation"
    :primary-text="actionText"
    @submit="primaryAction"
    @input="primaryAction"
  >
    {{ bodyText }}
  </sn-modal>
</template>

<script>
import snSessionsService from '~/services/snSessionsService.js'
import snModal from '../../snui/v2/snModal/snModal'

const MILLIS_IN_MINUTE = 60000

// I chose .5 mins as the check interval. The dialog only reports whole minutes so this should be sufficient.
const SESSION_CHECK_INTERVAL = 0.5 * MILLIS_IN_MINUTE

export default {
  name: 'SnSessionTimeoutModal',
  components: { snModal },
  props: {
    warningTitleText: {
      type: String,
      required: false,
      default: 'Are you still there?'
    },
    expiredTitleText: {
      type: String,
      required: false,
      default: 'Session expired'
    },
    warningActionText: {
      type: String,
      required: false,
      default: 'Keep working'
    },
    expiredActionText: {
      type: String,
      required: false,
      default: 'Okay'
    },
    // Replaces a placeholder of [MINUTES] with 'X minutes' or '1 minute'
    warningBodyText: {
      type: String,
      required: false,
      default: 'Your session will expire in [MINUTES]. All unsaved changes will be lost. Would you like to keep working?'
    },
    expiredBodyText: {
      type: String,
      required: false,
      default: 'Your session has expired. To continue, please sign in again.'
    }
  },
  data () {
    return {
      showDialog: false,
      sessionExpired: false,
      defaultSessionExpirationWarning: 10,
      defaultSessionExpires: 15,
      haveDefaultValues: false,
      sessionExpires: null,
      sessionExpiresWarning: null,
      timeout: null,
      timeUntilExpiration: null
    }
  },

  computed: {
    title () {
      if (this.sessionExpired) return this.expiredTitleText
      return this.warningTitleText
    },
    bodyText () {
      if (this.sessionExpired) return this.expiredBodyText
      return this.warningBodyText.replace('[MINUTES]', this.formattedTimeUntilExpiration)
    },
    actionText () {
      if (this.sessionExpired) return this.expiredActionText
      return this.warningActionText
    },
    formattedTimeUntilExpiration () {
      const timeInMinutes = Math.ceil(this.timeUntilExpiration / MILLIS_IN_MINUTE)
      if (timeInMinutes === 1) return '1 minute'
      return `${timeInMinutes} minutes`
    },
    isInAnIframe () {
      return window.self !== window.top
    }
  },

  created () {
    if (this.isInAnIframe) return
    this.restartTimeout()
    document.addEventListener('click', this.restartTimeout)
  },

  methods: {

    primaryAction () {
      if (this.sessionExpired) {
        console.log('Primary Action ' + this.sessionExpired)
        setTimeout(() => window.location.reload())
      } else {
        this.restartTimeout()
      }
    },

    restartTimeout (ping) {
      clearTimeout(this.timeout)
      this.showDialog = false
      this.sessionExpired = false

      const start = new Date().getTime()

      snSessionsService.ping()
        .then((response) => {
          this.defaultSessionExpires = response.data.sessionExpiresInMinutes
          this.defaultSessionExpirationWarning = response.data.sessionExpiresWarningMinutes
          if (this.defaultSessionExpires !== undefined && this.defaultSessionExpirationWarning !== undefined) {
            this.haveDefaultValues = true
          }
          this.sessionExpiresWarning = start + this.defaultSessionExpirationWarning * MILLIS_IN_MINUTE
          this.sessionExpires = start + this.defaultSessionExpires * MILLIS_IN_MINUTE
        })

      this.sessionExpiresWarning = start + this.defaultSessionExpirationWarning * MILLIS_IN_MINUTE
      this.sessionExpires = start + this.defaultSessionExpires * MILLIS_IN_MINUTE

      this.timeout = setInterval(() => {
        const now = new Date().getTime()
        this.timeUntilExpiration = this.sessionExpires - now
        if (this.timeUntilExpiration <= 0) {
          this.showDialog = true
          this.sessionExpired = true
        } else if (now >= (this.sessionExpiresWarning)) {
          this.showDialog = true
        }
      }, SESSION_CHECK_INTERVAL)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
